export default __webpack_public_path__ + "static/media/coursesCounter.d74e2f3a.svg";